import { defineStore } from 'pinia';
import Cookies from 'js-cookie';
import { Local } from '/@common/utils/storage';
import {roleList,queryMyAppRole,listHotAppRole,getAppRoleListByPubic,getAppRoleListUesdByUserId,getRecords} from "/@/api/chat/index"
import { router } from '/@/router';
/**
 * 角色有关配置
 */

const roleAndSkillMap = {
    'public': '舆情',
    'finance': '金融',
    'media': '媒体',
    'interviewer': '推荐',
    'officer': '推荐',
    'xiaoya': '推荐',
    'reporter': '媒体',
    'marketing': '营销',
    'python': '编程',
    'administration': '办公',
    'tourist': '生活',
}
const roleAndBackgroundMap = {
    'public': 'public_item',
    'finance': 'finance_item',
    'media': 'media_item',
    'interviewer': 'interviewer_item',
    'officer': 'finance_item',
    'xiaoya': 'xiaoya_item',
    'reporter': 'public_item',
    'marketing': 'finance_item',
    'python': 'xiaoya_item',
    'administration': 'media_item',
    'tourist': 'interviewer_item',
    'marketingExperts': 'interviewer_item',
    'publicOpinionAnalysis': 'media_item',
}
const roleAndIntroduceMap = {
    'public': '舆情专家助手',
    'finance': '金融专家助手',
    'media': '媒体专家助手',
    'interviewer': '专属面试官',
    'officer': '参谋专家助手',
    'xiaoya': '专属雅意',
    'reporter': '资深媒体记者',
    'marketing': '营销专家助手',
    'python': 'python编程专家',
    'administration': '行政专家助手',
    'tourist': '资深导游助手',
}

const convertRoleList = (list: any[]) => {
    return list.map(item => {
        return {
            roleId: item.id,
            code:item.code,
            isNew: item.isNew,
            isBeta: item.isBeta,
            createUser: item.createUser,
            roleName: item.roleName,
            custom: item.custom,
            roleText: item.roleDesc,
            roleIntroduce: roleAndIntroduceMap[item.icon],
            roleIcon: item.icon,
            roleBackground: roleAndBackgroundMap[item.icon],
            showTips:false,
            fileExtensions:item.fileExtensions,
            fileTypes:item.fileTypes,
            isParseUrl:item.isParseUrl,
            isUploadFile:item.isUploadFile,
            isDelete:item.isDelete,//智能体是否被删除
        }
    })
}

export const useRoleConfig = defineStore('roleConfig', {
    state: (): RoleConfigState => ({
        roleList: [],
        roleConfig: [],
        currentRoleCode: Local.get(`currentRoleCode`),
        currentRole:'',
        showRoleDialog: false,
        currentRoleInformation: {},
        defaultPlugin: '',
        defaultRole: '1658297003183144963',
        exampleQuestion: [],
        remainingRoleList: [],
        navRoleList: {},
        isDelete:'0',//true删除了
        shareLists:[],
        xiaoyaId:'',
        searchId:'',
        kyId: '',
        roleName:'',
        shareTitle:''
    }),
    actions: {
        async initRoleConfig() {
            const { code, data } = await getAppRoleListUesdByUserId();
            if (code !== 200) return;
            this.roleList = convertRoleList(data) as RoleConfigItem[];
            this.xiaoyaId=this.roleList.find(item=>item.code=='XIAOY')?.roleId
            this.searchId=this.roleList.find(item=>item.code=='ZHSSZJ')?.roleId
            this.kyId=this.roleList.find(item=>item.code=='KYZSeM1')?.roleId

   
            if (!this.currentRole) {
                const route = router.currentRoute.value; 
                if(route.name=='aiSearch'){
                    this.setCurrentRoleNew(this.roleList[1])
                    // this.currentRole=''
                }else if(route.name=='chat'){
                    this.setCurrentRoleNew(this.roleList[0])
                }else if(route.name=='assistant'){
                    this.setCurrentRoleNew(this.roleList[2])
                }
            }
            this.filterRoleList(this.roleList)
        },
        // pc端获取角色列表
        async initRoleConfigPc(params: string,type: string) {
            const { code, data } = type == 'all' ? await roleList({keyword: params}) : type == 'hot' ? await listHotAppRole({keyword: params}) : await queryMyAppRole({keyword: params})
            if (code !== 200) return;
            this.roleConfig = convertRoleList(data) as RoleConfigItem[];
        },
            // pc分享角色列表
            async initShareList(params: string) {
                const { code, data } = await getRecords({keyword: params})
                if (code !== 200) return;
                let shareList=convertRoleList(data) as RoleConfigItem[]
                this.shareLists=shareList
                //roleId
                // this.roleConfig.push(shareList) ;
                // console.log(this.roleConfig)
            },
        //pc获取智能体中心全部列表
        async initRoleConfigPcAll(params: string) {
            const { code, data } = await getAppRoleListByPubic({keyword: params})
            if (code !== 200) return;
            return data|| []
        },  
        getRoleConfig(): RoleConfigItem[] {
            return this.roleConfig;
        },
        getShareList(): RoleConfigItem[] {
            return this.shareLists;
        },
        filterRoleList(list: any) {
            const targetCodes = ["XIAOY", "ZHSSZJ","KYZSeM1"];
            this.navRoleList = {};
            this.remainingRoleList =  list.filter(role => {
                if (targetCodes.includes(role.code)) {
                    this.navRoleList[role.code] = role;
                    return false; // 从数组中过滤掉
                }
                return true;
            })
        },
        async setCurrentRoleNew (item: any) {
            let { roleId, code } = item
            if (code === 'KYZSeM1') {
                roleId = 'KYZSeM1'
            }
            if (code === 'ZHSSZJ') {
                roleId = 'ZHSSZJ'
            }
            this.currentRoleCode = code;
            this.currentRole = roleId;
            
            if (code === 'KYZSeM1') {
                this.currentRole='1829676855482630146'
                await router.push({ name: 'assistant' })
            } else if(code === 'ZHSSZJ'){
                this.currentRole='1793970575391633410'
                await router.push({ name: 'aiSearch' })
            }else {
                await router.push({ name: 'chat', params: { appId: roleId } })
            }
            
            
            // const userName = Cookies.get('userName');
            // const roleIdKey = `${userName}_roleId`;
            // Local.set(roleIdKey, roleId);
            // Local.set('currentRoleCode', code);
        },
        setCurrentRole(roleId: string) {
            this.currentRole = roleId;
            // const userName = Cookies.get('userName');
            // const roleIdKey = `${userName}_roleId`;
            // Local.set(roleIdKey, roleId);
        },
        getCurrentRole(): string {
            return this.currentRole;
        },
        getCurrentRoleByRoleId(roleId: string): RoleConfigItem {
            return this.roleConfig.find((item) => item.roleId === roleId)!;
        },
        setShowRoleDialog(show: boolean) {
            this.showRoleDialog = show;
            const userName = Cookies.get('userName');
            const roleDialogKey = `${userName}_roleDialog`;
            Local.set(roleDialogKey, show);
        },
        getShowRoleDialog(): boolean {
            const userName = Cookies.get('userName');
            const roleIdKey = `${userName}_roleId`;
            const roleId = Local.get(roleIdKey);
            if (this.getCurrentRoleByRoleId(roleId)) return this.showRoleDialog;
            return true;
        },
        getRoleAndSkillMap(): Record<string, string> {
            return roleAndSkillMap;
        },
        setRoleInformation(data:object) {
            this.currentRoleInformation = data
            this.isDelete=data.isDelete
        },
        setRoleDefaultPlugin(roleName: string) {
            this.defaultPlugin = roleName;
        },
        getRoleDefaultPlugin(): string {
            return this.defaultPlugin;
        },
    },
});
